export const UIBlockerBlockEvent = 'pmi.web.uiblocker__enable';
export const UIBlockerUnblockEvent = 'pmi.web.uiblocker__disable';
